import React, {useEffect} from 'react';
import desktop from './window_info_coupon_img.png';
import mobile from './window_info_coupon_img_m.png';
import {useDispatch, useSelector} from "react-redux";
import {savePlayerSettingsAsync} from "../../store/spirs/actions";
import {useTranslation} from "react-i18next";
import {StoreType} from "../../store/spirs/types";
import {acceptWelcome} from "../../spirsApi/api-client";
import {useNavigate} from "react-router-dom";

export const CouponChooseMethodSetting = () => {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(true);
    const [needConfirm, setNeedConfirm] = React.useState<'needConfirm' | 'dontNeedConfirm'>('needConfirm');
    const playerSettings = useSelector((state: StoreType) => state.spirs.playerSettings);
    const ref = React.useRef<HTMLDivElement>(null);

    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        setNeedConfirm(playerSettings.needConfirm ? 'needConfirm' : 'dontNeedConfirm');
    }, [playerSettings.needConfirm]);

    const handleChange = (event: any) => {
        setNeedConfirm(event.currentTarget.value);
    };

    const handleConfirm = () => {
        const newPlayerSettings = {
            ...playerSettings,
            needConfirm: needConfirm === 'needConfirm'
        };
        dispatch(savePlayerSettingsAsync.request({model: newPlayerSettings}));
        acceptWelcome();
        setOpen(false);
        navigate('/');

    };

    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent): void {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }

        // @ts-ignore
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // @ts-ignore
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const color = needConfirm === 'needConfirm' ? 'inherit' : 'rgba(72,76,86,0.8)';
    const color2 = needConfirm === 'dontNeedConfirm' ? 'inherit' : 'rgba(72,76,86,0.8)';
    return (
        <>
            {open && (
                <>
                    <div className="absolute z-[11] top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2">
                        <div className="bg-white text-black max-w-[540px] p-[16px] tablet:px-[61px] rounded-md" ref={ref}>
                            <h1>{t('settings.initialDialogSettings.title')}</h1>
                            <h4 className="text-[#358ED7] py-[13px]">
                                {t('settings.initialDialogSettings.chooseMethod')}
                            </h4>
                            <div className="flex justify-center">
                                <img
                                    alt={'initialDialogSettings img'}
                                    src={mobile}
                                    className="tablet:hidden shadow-[0_0_4px_0_rgba(0,0,0,0.5)]"
                                />
                                <img
                                    alt={'initialDialogSettings img'}
                                    src={desktop}
                                    className="max-tablet:hidden shadow-[0_0_4px_0_rgba(0,0,0,0.5)]"
                                />
                            </div>
                            <div className="bg-white text-left">
                                <div className="flex mb-4 items-start gap-[5px]">
                                    <input
                                        id="needConfirm"
                                        type="radio"
                                        value="needConfirm"
                                        className="mt-[7px] scale-[1.5]"
                                        onChange={handleChange}
                                        checked={needConfirm === 'needConfirm'}
                                    />
                                    <label className="text-[16px]" style={{ color }}>
                                        {t('settings.initialDialogSettings.needConfirm')}
                                    </label>
                                </div>
                                <div className="flex items-start gap-[5px]">
                                    <input
                                        type="radio"
                                        value="dontNeedConfirm"
                                        className="mt-[7px] scale-[1.5]"
                                        onChange={handleChange}
                                        checked={needConfirm === 'dontNeedConfirm'}
                                    />
                                    <label className="text-[16px]" style={{ color: color2 }}>
                                        {t('settings.initialDialogSettings.dontNeedConfirm')}
                                    </label>
                                </div>

                                <div className="flex justify-center flex-row py-[12px]">
                                    <button
                                        className="rounded-[16px] bg-[#90C572] text-white w-96 py-[12px] basis-[318px] shadow-[0_1px_2px_0_rgba(0,0,0,0.5)]"
                                        onClick={handleConfirm}
                                    >
                                            <span className="text-[16px] font-bold">
                                                {t('settings.initialDialogSettings.confirmButton')}
                                            </span>
                                    </button>
                                </div>
                                <div className="flex justify-center flex-row">
                                        <span className="text-[12px] font-medium text-[rgba(0, 0, 0, 0.54)]">
                                            {t('settings.initialDialogSettings.changeSelection')}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

